import { createFileRoute } from '@tanstack/react-router';

import { DefaultSettingsContainer } from '@/features/settings/containers/default-settings';

export const Route = createFileRoute('/_layout/settings/_layout/default-settings/')({
  component: DefaultSettingsContainer,
});
